import constants from "../../constants";
import { useContext, useState } from "react";
import { getDataFromStorage } from "../../util";
import useAxiosPrivate from "../useAxiosPrivate";
import AlertContext from "../../context/AlertContext";
import useCommonFunctionHooks from "../useCommonFunctionHooks";
import InstructionPageWizardHooks from "./InstructionPageWizardHooks";

export default function ConnectPhoneHooks() {
  const Alert = useContext(AlertContext);

  const axios = useAxiosPrivate();
  const { steps, handleNext } = InstructionPageWizardHooks();

  const { getCatchBlockDetails, getHeaderDetailsForAxios } =
    useCommonFunctionHooks();

  const [QRDetail, setQRDetail] = useState({});

  const generateQR = () => {
    axios
      .post(
        "node/learner/dp/QR/generate",
        JSON.stringify({
          userId: getDataFromStorage("learnerid"),
        }),
        getHeaderDetailsForAxios()
      )
      .then((res) => {
        if (res.data.resultCode === constants.RESULT_STATUS.SUCCESS) {
          setQRDetail(res.data.data);
        } else {
          Alert.setShowNotify({
            show: true,
            title: "Warning",
            msg: res.data.msg,
          });
        }
      })
      .catch((error) => {
        getCatchBlockDetails(error);
      });
  };

  const validateToken = () => {
    axios
      .post(
        "node/learner/dp/validate",
        JSON.stringify({
          userId: getDataFromStorage("learnerid"),
        }),
        getHeaderDetailsForAxios()
      )
      .then((res) => {
        if (res.data.resultCode === constants.RESULT_STATUS.SUCCESS) {
          if (
            res.data.status &&
            !Alert.testData.verifyPic &&
            steps[Alert.currentStep] === "Instructions"
          ) {
            return Alert.setShowNotify({
              show: true,
              title: "Warning",
              primaryButtonFunction: () => handleNext("back"),
              msg: "Please verify your mobile photo before proceeding.",
            });
          } else {
            handleNext();
          }
        } else {
          Alert.setShowNotify({
            show: true,
            title: "Warning",
            msg: res.data.msg,
          });
        }
      })
      .catch((error) => {
        getCatchBlockDetails(error);
      });
  };

  return { QRDetail, generateQR, validateToken };
}
